import { FileText, ExternalLink } from 'lucide-react'
import { formatTimeAgo } from '@/lib/dateUtils'
import { formatUrl } from './utils'

interface PageHistoryItemProps {
  page: { url: string; title: string | null; at: string }
}

export function PageHistoryItem({ page }: PageHistoryItemProps) {
  const displayTitle = page.title || formatUrl(page.url)
  const timeAgo = formatTimeAgo(page.at)

  return (
    <a
      href={page.url}
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center gap-2 p-2 rounded hover:bg-muted/50 transition-colors group cursor-pointer"
    >
      <FileText className="size-4 text-muted-foreground shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="text-sm truncate group-hover:text-primary transition-colors">
          {displayTitle}
        </p>
        <p className="text-xs text-muted-foreground">{timeAgo}</p>
      </div>
      <ExternalLink className="size-3 text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity" />
    </a>
  )
}
